import { useState, useEffect, useRef } from "react";

// assets
import DownArrow from "bodycodi/cmap/app/img/down.png";

// utils
import { contractTableMoneyFormat, moneyFormatter } from "bodycodi/cmap/app/js/common";

const AppointmentCollapsibleCard = ({ pricing, allowanceType }: any) => {
  const wrapRef: any = useRef(null);
  const foldRef: any = useRef(null);
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (open) {
      const height = foldRef.current.offsetHeight;
      wrapRef.current.style.height = height + "px";
    } else {
      wrapRef.current.style.height = 0;
    }
  }, [open]);

  return (
    <div className="collapsible-card">
      <div className="top">
        <div className="title">
          <span>{pricing?.pricingName}</span>
          <img src={DownArrow} onClick={() => setOpen(!open)} className={open ? " open" : ""} />
        </div>

        <div className="tags">
          <span>{moneyFormatter(pricing?.price)}</span>
          <span>{`${pricing?.usePeriod}${pricing?.usePeriodType === "M" ? "개월" : "일"}`}</span>
          <span>{`${pricing?.serviceKind === "N" ? pricing?.useNumber + "회" : "무제한"}`}</span>
        </div>
      </div>

      {!!pricing?.sections?.length && (
        <div className="fold-wrap" ref={wrapRef}>
          <div className="fold" ref={foldRef}>
            <table className="card-table">
              <thead style={{ height: 36 }}>
                <tr>
                  <th colSpan={3} style={{ minWidth: 255, border: "none" }}>
                    구간 정보
                  </th>
                  <th style={{ borderRight: "none", minWidth: 120 }}>{`신규 결제 수당 (${
                    allowanceType === "AMOUNT" ? "원" : "%"
                  })`}</th>
                  <th style={{ borderRight: "none", minWidth: 105 }}>{`재결제 수당 (${
                    allowanceType === "AMOUNT" ? "원" : "%"
                  })`}</th>
                </tr>
              </thead>
              <tbody>
                {pricing?.sections?.map((section: any, index: number) => {
                  return (
                    <tr key={index}>
                      <td
                        colSpan={3}
                        className="blue-text"
                        style={{ borderRight: "1px solid #e3e5e8" }}
                      >
                        {`${contractTableMoneyFormat(
                          section?.sectionMore,
                          "이상"
                        )} ${contractTableMoneyFormat(section?.sectionLess, "이하")}`}
                      </td>
                      <td className={section?.newPayroll > 0 ? "active" : ""}>
                        {allowanceType === "AMOUNT"
                          ? moneyFormatter(section?.newPayroll, true)
                          : section?.newPayroll}
                      </td>
                      <td
                        className={section?.inusePayroll > 0 ? "active" : ""}
                        style={{ borderRight: "none" }}
                      >
                        {allowanceType === "AMOUNT"
                          ? moneyFormatter(section?.inusePayroll, true)
                          : section?.inusePayroll}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

const GroupCollapsibleCard = ({ lesson, allowanceType }: any) => {
  const wrapRef: any = useRef(null);
  const foldRef: any = useRef(null);
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (open) {
      const height = foldRef.current.offsetHeight;
      wrapRef.current.style.height = height + "px";
    } else {
      wrapRef.current.style.height = 0;
    }
  }, [open]);

  return (
    <div className="collapsible-card">
      <div className="top">
        <div className="title">
          <span dangerouslySetInnerHTML={{ __html: lesson?.lessonName }}></span>
          <img src={DownArrow} onClick={() => setOpen(!open)} className={open ? " open" : ""} />
        </div>

        <div className="tags">
          <span className="active">{`정원 ${lesson?.lessonMaximumNo}명`}</span>
          <span>{`${lesson?.lessonTime}분 진행`}</span>
        </div>
      </div>

      {!!lesson?.sections?.length && (
        <div className="fold-wrap" ref={wrapRef}>
          <div className="fold" ref={foldRef}>
            <table className="card-table" style={{ display: "table" }}>
              <thead style={{ height: 36 }}>
                <tr>
                  <th colSpan={3} style={{ width: "70%", border: "none" }}>
                    구간 정보
                  </th>
                  <th style={{ borderRight: "none", width: "30%" }}>{`수당 (${
                    allowanceType === "AMOUNT" ? "원" : "%"
                  })`}</th>
                </tr>
              </thead>
              <tbody>
                {lesson?.sections?.map((section: any, index: number) => {
                  return (
                    <tr key={index}>
                      <td
                        colSpan={3}
                        className="blue-text"
                        style={{ borderRight: "1px solid #e3e5e8" }}
                      >
                        {`${section?.sectionMore}명 부터 ${
                          section?.sectionLess ? section?.sectionLess + "~ 명 까지" : ""
                        }`}
                      </td>
                      <td className={section?.newPayroll > 0 ? "active" : ""}>
                        {allowanceType === "AMOUNT"
                          ? moneyFormatter(section?.newPayroll, true)
                          : section?.newPayroll}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export { AppointmentCollapsibleCard, GroupCollapsibleCard };
